<div
   class="sam-full-width sam-full-height"
   cdkDropList
   [id]="zoneId"
   (cdkDropListDropped)="drop($event)"
   (mouseenter)="enterZone()"
   (mouseleave)="leaveZone()"
>
   <div
      *ngIf="!hasContent && !(draggedItemKey | isNil | async) && !(isDropListEntered$ | async)"
      class="sam-border-bottom sam-opacity-medium"
   ></div>
   <div *ngIf="!hasContent && !(draggedItemKey | isNil | async) && (isDropListEntered$ | async)" class="sam-draggable">
      <ng-content select="[dropPreview]"></ng-content>
   </div>
   <div *ngIf="hasContent">
      <ng-content class="sam-full-width" select="[itemContent]"></ng-content>
   </div>
</div>
